

export default {
  data() {
    return {
      isActive: false,
      loginFlag: false,
      top: 0,
    }
  },
  watch: {
    $route: function (val) {
      if (val.path == '/') {
        this.isActive = false
      } else {
        this.isActive = true
      }

    },
  },
  mounted() {
  },
  methods: {
    gotoEsim() {
      window.localStorage.setItem("esim", "true")
      this.$router.push({ path: '/esim' })
    },
    loginClick() {
      this.$emit("loginClick", true)
    },
  },
}
